// extracted by mini-css-extract-plugin
module.exports = {"page":"KC-z","cartModal":"LC-z","checkout":"MC-z","placeholder":"NC-z","account":"OC-z"};